module.exports = __webpack_public_path__ + "img/favicon-image.b3ab9557.png";